import type { PersonMediaType } from '@repo/config';
import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPersonPhotoResponse } from '../person-photo-response';
import { personPhotoResponseSchema } from '../person-photo-response';

export interface IAddPersonPhotoInput {
  file: File;
  mediaType?: PersonMediaType;
  caption?: string;
}

export async function addPersonPhotoApi(
  id: number,
  input: IAddPersonPhotoInput,
): Promise<IValidatedResponse<IPersonPhotoResponse>> {
  const body = new FormData();
  body.append('file', input.file);
  if (input.mediaType) {
    body.append('mediaType', input.mediaType);
  }
  if (input.caption) {
    body.append('caption', input.caption);
  }
  return postRequest<IPersonPhotoResponse>({
    path: `/sys/people/v1/${id}/photos`,
    body,
    schema: personPhotoResponseSchema,
  });
}
